/**
 * Forwarding API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface CommentDTO { 
    id?: number;
    code?: string;
    description?: string;
    isBlocked?: boolean;
    isDeleted?: boolean;
    masterDataStatus?: CommentDTO.MasterDataStatusEnum;
    commentType?: CommentDTO.CommentTypeEnum;
}
export namespace CommentDTO {
    export type MasterDataStatusEnum = 0 | 1;
    export const MasterDataStatusEnum = {
        NUMBER_0: 0 as MasterDataStatusEnum,
        NUMBER_1: 1 as MasterDataStatusEnum
    };
    export type CommentTypeEnum = 0 | 1 | 2 | 3;
    export const CommentTypeEnum = {
        NUMBER_0: 0 as CommentTypeEnum,
        NUMBER_1: 1 as CommentTypeEnum,
        NUMBER_2: 2 as CommentTypeEnum,
        NUMBER_3: 3 as CommentTypeEnum
    };
}